import { del, get, post, put } from "../../services/ApiRouting";

// Function to fetch all
export async function getAllCategories(page = 1) {
  try {
    const response = await get(`${API_URL}/crud/categories?page=${page}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching all :", error);
    throw error.response ? error.response.data : new Error("Network Error");
  }
}

// Function to create a new pay
export async function createCategory(payData) {
  try {
    const formData = new FormData();
    formData.append("name", payData.name);
    if (payData.file) {
      formData.append("image", payData.file);
    }

    const response = await post(`${API_URL}/crud/categories`, formData);
    return response;
  } catch (error) {
    console.error("Error creating pay:", error);
    throw error.response ? error.response.data : new Error("Network Error");
  }
}

// Function to fetch a single pay by ID
export async function getCategoryById(token, payId) {
  try {
    const response = await axios.get(`${API_URL}/crud//${payId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching pay with ID ${payId}:`, error);
    throw error.response ? error.response.data : new Error("Network Error");
  }
}

// Function to update an existing pay
export async function updateCategory(payId, payData) {
  try {
    const formData = new FormData();
    formData.append("name", payData.name);
    if (payData.file) {
      formData.append("image", payData.file);
    }
    if (payData.capital) {
      formData.append("capital", payData.capital);
    }

    const response = await put(`${API_URL}/crud/categories/${payId}`, formData);
    return response;
  } catch (error) {
    console.error(`Error updating pay with ID ${payId}:`, error);
    throw error.response ? error.response.data : new Error("Network Error");
  }
}

// Function to delete a pay
export const deleteCategory = async (id) => {
  try {
    const response = await del(`${API_URL}/crud/categories/${id}`);
    return response;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to delete pay");
  }
};
